import { sortedUniqueCountryCodes } from 'shared/util/countryCodes';
import { isYoungerThan18 } from 'shared/util/datetime-fns';

export const invalidNameField = (name: string, fieldName?: string) => {
    if (name.trim().length < 1) {
        return `${fieldName} må fylles ut.`;
    }
    if (name.trim().length > 50) {
        return 'Du kan benytte maksimalt 50 tegn.';
    }
    return null;
};

export const invalidMessageField = (message: string) => {
    if (message.trim().length < 1) {
        return 'Melding må fylles ut.';
    }
    if (message.trim().length > 1000) {
        return 'Du kan benytte maksimalt 1000 tegn.';
    }
    return null;
};

export const invalidEmail = (email: string) => {
    if (email.trim().length < 1) {
        return 'Email må fylles ut.';
    }
    if (!email.includes('@')) {
        return 'Gyldig email adresse må fylles ut.';
    }
    if (email.trim().length < 6) {
        return 'Gyldig email adresse må fylles ut.';
    }
    if (email.trim().length > 40) {
        return 'Du kan benytte maksimalt 40 tegn.';
    }
    return null;
};

const dateFromParts = (day: string, month: string, year: string): Date | null => {
    if (!day || !month || !year) return null;
    const dayNum = Number(day);
    const monthNum = Number(month);
    const yearNum = Number(year);
    const date = new Date(yearNum, monthNum, dayNum);
    return isValidDate(date) ? date : null;
};

export const invalidBirthDate = (dateOfBirthOrDay: string, month?: string, year?: string) => {
    if (month !== undefined && year !== undefined) {
        const date = dateFromParts(dateOfBirthOrDay, month, year);
        return date ? null : 'Gyldig fødselsdato må fylles ut.';
    }
    if (!dateOfBirthOrDay) return 'Gyldig fødselsdato må fylles ut.';
    const date = new Date(dateOfBirthOrDay);
    return isValidDate(date) ? null : 'Gyldig fødselsdato må fylles ut.';
};

export const tooYoung = (dateOfBirthOrDay: string, month?: string, year?: string) => {
    if (month !== undefined && year !== undefined) {
        const date = dateFromParts(dateOfBirthOrDay, month, year);
        return date && isYoungerThan18(date) ? 'Du må være over 18 år for å sende en forespørsel.' : null;
    }
    if (!dateOfBirthOrDay) return null;
    const date = new Date(dateOfBirthOrDay);
    return isValidDate(date) && isYoungerThan18(date) ? 'Du må være over 18 år for å sende en forespørsel.' : null;
};

export const birthDateTooOld = (dateOfBirthOrDay: string, month?: string, year?: string) => {
    if (month !== undefined && year !== undefined) {
        const date = dateFromParts(dateOfBirthOrDay, month, year);
        if (!date) return null;
        return date.getFullYear() < 1900 ? 'Fødselsdato må være etter år 1900.' : null;
    }
    if (!dateOfBirthOrDay) return null;
    const date = new Date(dateOfBirthOrDay);
    if (!isValidDate(date)) return null;
    return date.getFullYear() < 1900 ? 'Fødselsdato må være etter år 1900.' : null;
};

export const invalidPhone = (landcode: string, phone: string) => {
    if (landcode === '+47' && phone.trim().length !== 8) {
        return 'Norske telefonnummer må være 8 siffer.';
    }
    if (phone.trim().length < 5) {
        return 'Mobiltelefon må fylles ut.';
    }
    if (phone.trim().length > 17) {
        return 'Mobiltelefon er for langt.';
    }
    return null;
};

export const splitPhoneNumber = (phoneNumber?: string | null): { basePhoneNumber: string; landCode: string } | null => {
    if (!phoneNumber || !phoneNumber.startsWith('+')) return null;
    const matchedCode = [...sortedUniqueCountryCodes].sort((a, b) => b.length - a.length).find((cc) => phoneNumber.startsWith(`+${cc}`));
    if (!matchedCode) return null;
    const landCodeWithPlus = `+${matchedCode}`;

    return {
        landCode: landCodeWithPlus,
        basePhoneNumber: phoneNumber.slice(landCodeWithPlus.length),
    };
};

export const isValidDate = (date: Date) => date instanceof Date && !Number.isNaN(date.getTime());
